
import React from 'react';
import { useSelector } from 'react-redux';

const RootLogged = (props) => {

    const user = useSelector(state => {
        return state.auth.data ? state.auth.data.user : null;
    });
    const loading = useSelector(state => {
        return state.auth.loading;
    });

    if (loading) {
        return <div>Nahrávám...</div>
    } else {
        const {appComponent, ...restProps} = props;
        return React.createElement(appComponent, restProps);
    }
}

export default RootLogged;
